<div class="faq-container">
  <h2 class="header"><adp-label labelKey="FAQ_Heading_Text"></adp-label></h2>
  <div class="faq-inner-container">
    <div class="faq-image" *ngIf="faqImageUrl">
      <img [src]="faqImageUrl" [alt]="faqImageAltText" />
    </div>
    <div class="faq-list-container">
      <mat-accordion *ngIf="faqListItems?.length > 0">
        <mat-expansion-panel
          displayMode="flat"
          hideToggle
          *ngFor="let faqItem of faqListItems; let i = index"
          (opened)="setOpened(i)"
          (closed)="setClosed(i)"
          class="faq-item-container"
          [gtmClick]="getViewLabel(faqItem.questionKey)"
          gtmEventCategory="accordion_expand"
          [gtmLinkClasses]="getViewLabel('FAQ_Heading_Text')">
          <mat-expansion-panel-header class="faq-question-container">
            <mat-panel-title>
              <mat-icon class="faq-icon-container" [svgIcon]="currentlyOpenedItemIndex === i ? 'subtract' : 'add'"></mat-icon>
              <span class="faq-question"><adp-label labelKey="{{ faqItem.questionKey }}"></adp-label></span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="faq-answer-container">
            <div class="faq-answer"><adp-label labelKey="{{ faqItem.answerKey }}"></adp-label></div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <adp-setting key="ClaimsSupportCenter_MoreFAQs_Enabled"></adp-setting>
      <div class="logo-xl" ifSettingTrue="ClaimsSupportCenter_MoreFAQs_Enabled">
        <adp-label labelKey="ClaimsSupportCenter_MoreFAQs"></adp-label>
      </div>
    </div>
  </div>
</div>
